import {Pipe,PipeTransform} from "@angular/core";
import * as moment from "moment-timezone";
import {LocaleService} from "@services/admin/langue/locale.service";

/**
 * Pipe custom pour le formatage des dates
 * /!\ Surcharge du datePipe Angular pour pouvoir utiliser la timezone configurée par défaut
 *
 * @author Laurent Convert
 * @date 06/03/2025
 * @see AppComponent
 */
@Pipe({
    name: 'date'
})
export class DatePipe implements PipeTransform {

    constructor(private localeService: LocaleService) {}

    transform(value: Date | moment.Moment | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null {
        let momentFormat = '';
        let momentDate;

        //Retour null si pas de valeur (sinon moment prend d'office la date du jour)
        if (!value) { return null; }

        //Mapping vers le format momentjs à partir du format Angular
        switch (format) {
            case 'short':
                momentFormat = 'L LT';
                break;
            case 'medium':
                momentFormat = 'lll:ss';
                break;
            case 'full':
                momentFormat = 'LLLL:ssZ';
                break;
            case 'shortDate':
                momentFormat = 'L';
                break;
            case 'mediumDate':
                momentFormat = 'll';
                break;
            case 'longDate':
                momentFormat = 'LL';
                break;
            case 'fullDate':
                momentFormat = 'dddd LL';
                break;
            case 'shortTime':
                momentFormat = 'LT';
                break;
            case 'mediumTime':
                momentFormat = 'LTS';
                break;
            case 'fullTime':
                momentFormat = 'LTSZ';
                break;
        }

        //Vérification du type de la valeur
        if (moment.isMoment(value)) {
            //Si c'est déjà une date moment, on la conserve
            momentDate = value;
        } else {
            //Sinon construction d'un objet moment à partir de la valeur
            momentDate = moment(value);
        }

        //Gestion de la timezone le cas échéant
        if (timezone) {
            momentDate = momentDate.tz(timezone);
        }

        //Gestion de la locale le cas échéant
        //Si une locale est spécifiée explicitement, on l'utilise
        //Sinon on utilise la locale configurée dans le service
        const localeToUse = locale ? locale : this.localeService.currentLocale;
        momentDate = momentDate.locale(localeToUse);

        //Retour de la date formatée
        return momentDate.format(momentFormat);
    }

}
